import {Injectable} from "@angular/core";
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import {LocationStrategy} from "@angular/common";
import {FreelancersService} from "./freelancers.service";

@Injectable()

export class SearchService{

    data: Observable<any[]>;

    constructor(
        private locationSt: LocationStrategy,
        private freelancerServ: FreelancersService
    ){

    }

    getTerms(){
        return this.data;
    }

    setTerm(value: string){

    }

    fetchTerm(){

    }

    fetchResults(value){
        const activeR = this.locationSt.path().split('/')[1];
        console.log(value, activeR);
        this.data = this.freelancerServ.searchFreelancers(value);
    }
}


// WEBPACK FOOTER //
// /Users/moe.dchater/personal/firebase-projects/hosting/src/app/services/search.service.ts